/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import HintBox from "@/src/components/Box/HintBox/HintBox";
import React from "react";

const SummaryHintBox = () => {
  return (
    <HintBox headline={"Bitte überprüfen Sie Ihre Angaben!"}>
        Überprüfen Sie hier kurz Ihre Angaben. Sollten Änderungen nötig sein, klicken Sie am Ende der Seite auf “Alles bearbeiten”, um den Vorgang noch einmal
        von vorn zu starten.
    </HintBox>
  );
};

export default SummaryHintBox;
